
/**
 * @description
 * 로드맵 상세 > 로드맵은 어떤 차이가 있나요?
 */

export default {
  name: 'WhatIsDifferent',
};
